import BankList from "Components/BankList/BankList";
import "./MyAccounts.scss";
import { Box, Link, Stack, Typography } from "@pav/pav-products-design-system";
import React, { useEffect, useState } from "react";
import LoadVipAccount from "Components/LoadVipAccount";
import { PRODUCTTYPES } from "Utils/Constants";
import RoutingInfoModal from "Pages/FundsPage/RoutingInfoModal";
import { useLimitAndProductSwitching } from "./useLimitAndProductSwitching";

const MyAccounts = () => {
  const {
    onVipOnlineSubmit,
    onVipPreferredSubmit,
    showModals,
    patronProductType,
    patronSelectedProductType,
    isOperatorBoth,
    productType,
    productRoutingEnabled,
    determineProductSwitchAndLimits,
    apiReady,
  } = useLimitAndProductSwitching();

  useEffect(() => {
    if (!apiReady) return;
    let mounted = true;
    determineProductSwitchAndLimits(mounted);
    return () => {
      mounted = false;
    }; // Unmount func
  }, [apiReady]);

  const [showMessage, setShowMessage] = useState(
    patronProductType !== patronSelectedProductType &&
      isOperatorBoth &&
      !productRoutingEnabled,
  );
  const pageTitle = productType + " - My Accounts";
  document.title = pageTitle;
  const title = "My Funding Sources";

  return (
    <>
      <Stack
        className="my-accounts"
        sx={{
          alignItems: { xs: "left", md: "center" },
          gap: "var(--spacing-md)",
        }}
      >
        {showModals && (
          <>
            {patronSelectedProductType === PRODUCTTYPES.PREFERRED && (
              <RoutingInfoModal
                handleCloseModal={() => setShowMessage(false)}
                title="You're using VIP Online"
                body={
                  <Box>
                    Continue your transaction to enjoy personalized spending
                    limits based on each of your bank accounts.{" "}
                    <span>
                      <Link
                        onClick={onVipPreferredSubmit}
                        sx={{
                          color: "var(--color-text-link)",
                          fontWeight: 700,
                        }}
                      >
                        Try VIP Preferred ACH
                      </Link>
                    </span>{" "}
                    for benefits and potential higher funding limits.
                  </Box>
                }
              />
            )}
            {patronSelectedProductType === PRODUCTTYPES.ONLINE && (
              <RoutingInfoModal
                handleCloseModal={() => setShowMessage(false)}
                title="You're a VIP Preferred ACH member"
                body={
                  <Box>
                    Continue your transaction to enjoy your membership benefits
                    and potential higher funding limits.
                    <span>
                      <Link
                        onClick={onVipOnlineSubmit}
                        sx={{
                          color: "var(--color-text-link)",
                          fontWeight: 700,
                        }}
                      >
                        Try VIP Online
                      </Link>
                    </span>{" "}
                    to enjoy personalized spending limits based on each of your
                    bank accounts.
                  </Box>
                }
              />
            )}
          </>
        )}
        <Typography variant="h3" color="navy" weight="bold">
          {title}
        </Typography>
        <Typography weight="bold">Select the default funding source</Typography>
        <LoadVipAccount>
          <BankList />
        </LoadVipAccount>
      </Stack>
    </>
  );
};

export default MyAccounts;
